import { useEffect, useState } from 'react';
import { useAuthUser } from 'auth/useAuthUser';


export function useAuthStatus() {

  const { user, isLoading } = useAuthUser();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  useEffect(() => {
    if (!isLoading) {
      const isLoggedIn = !!user && !user.expired;
      if (isLoggedIn !== isAuthenticated) {
        setIsAuthenticated(isLoggedIn);
      }
    }
  }, [user, isLoading]);

  return { isAuthenticated, isLoading };
}
